import React from "react";
import { Button } from "react-bootstrap";

function ButtonsYesNo(props) {
  return (
    <div>
      <Button
        variant="outline-secondary"
        className="btn150px btn-lg mr-4 px-5"
        onClick={(e) => props?.handleCloseModal(e)}
      >
        No
      </Button>
      <Button
        variant="danger"
        className="btn150px btn-lg px-5"
        onClick={(e) => props?.onClearAllReadItem(e)}
      >
        Yes
      </Button>
    </div>
  );
}

export default ButtonsYesNo;
